"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Highlighted = exports.default = void 0;
var highlighted_component_1 = require("./highlighted.component");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(highlighted_component_1).default; } });
Object.defineProperty(exports, "Highlighted", { enumerable: true, get: function () { return highlighted_component_1.Highlighted; } });
